"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DesktopDisabled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5.739,4.99995562 L6.472,5.99995562 L5,6 L5,16 L13.806,15.9999556 L15,17.6279556 L15,19 L16.006,18.9999556 L16.6911108,20 L6,20 L6,19 L9,19 L9,17 L5,17 C4.44771525,17 4,16.5522847 4,16 L4,6 C4,5.44771525 4.44771525,4.99995562 5,4.99995562 L5.739,4.99995562 Z M14,17 L10,17 L10,19 L14,19 L14,17 Z M6.84355718,3.13660584 L6.9032025,3.20431817 L17.9032025,18.2043182 C18.0665031,18.4270008 18.0183644,18.7399019 17.7956818,18.9032025 C17.5977418,19.0483586 17.3285179,19.0264515 17.1564428,18.8633942 L17.0967975,18.7956818 L6.0967975,3.79568183 C5.93349694,3.57299924 5.98163558,3.26009807 6.20431817,3.0967975 C6.40225825,2.95164144 6.67148215,2.97354846 6.84355718,3.13660584 Z M9.46,4.99995562 L19,4.99995562 C19.5522847,4.99995562 20,5.44771525 20,6 L20,16 C20,16.5522847 19.5522847,17 19,17 L18.26,17 L17.527,15.9999556 L19,16 L19,6 L10.193,5.99995562 L9.46,4.99995562 Z" })));
};
DesktopDisabled.displayName = 'DesktopDisabled';
exports.default = DesktopDisabled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DesktopDisabled.js.map